import imageLoader from 'utils/image-loader';

imageLoader.activate();
